export * from './utishaAuthApi.service';
import { UtishaAuthApiService } from './utishaAuthApi.service';
export const APIS = [UtishaAuthApiService];
